const arr = [
  { type: 'first',
    name: 'first',
    title: '使用前必读',
    description: '软件依赖的系统环境、软件版本要求，以及使用规则。',
    date: '2023-7-23',
    values: [
      { type: 'text',
        name: 'top1',
        title: '软件版本要求',
        content: `<p>系统版本：Windows10/11 64位；依赖 .NET Core 6.0以上<a href="#idcore">
                  (下载）</a>和 .NET Framework 4.7.2以上<a href="#idframe">
                  (下载）</a>。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）</a>。</p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020）</a>。</p>
                  <p>请先安装office和Adobe Acrobat DC软件后，再安装本软件，避免安装出错。</p>`
      },
      { type: 'text',
        name: 'top2',
        title: '前序配置',
        content: `<p> 在使用前，请按《代码使用注意事项.docx》做好文件配置，相关的资源文件不要删除。</p>
        <p>设置doc/docx文件类型打开方式默认为word，设置pdf文件类型打开方式默认为Acrobat DC。<span class="text-red">如装有WPS软件或新安装WPS，请务必按注意事项安装
        </span>。<a href="http://www.booleanda.cc:9600" target="_blank">（点击下载EXCEL版本）</a></p>
        <p><span class="text-red">同时，在运行代码时，不要打开使用word和Acrobat软件。</span> </p>
        <p>运行中如需强制退出，按Ctrl+Alt+Delete键【任务管理器】—找到进程【BooleanDA.exe】/【Adobe Acrobat DC 32位】—结束进程。 </p>`
      },
      { type: 'text',
        name: 'top3',
        title: '使用约定',
        content: `<p>本软件可申请免费试用一个月。其中，激活码验证版本可支持离线/内网环境使用。 </p>
        <p>账号在验证后，<span class="text-red">仅可在首次验证登录的机器使用，一机一码，暂无法在其他电脑上使用。</span>  </p>
        <p>软件依赖于本地电脑的office 16/Adobe Acrobat DC软件实现，所有文档操作均在本地电脑进行，联网仅执行账号验证，不会收集任何文档信息，确保文档信息安全。</p>`
      },
      { type: 'text',
        name: 'top4',
        title: '.NET Core 6.0下载',
        content: `<p id="idcore">进入官网下载页面后，请选择安装桌面运行时windows的x64和x86版本，如下图<a href="https://dotnet.microsoft.com/zh-cn/download/dotnet/6.0" target="_blank">
                  (开始点击下载.NET Core 6.0）</a> </p>`
      },
      { type: 'image',
        content: 'core6.png'
      },
      { type: 'text',
        name: 'top5',
        title: '.NET Framework 4.7.2下载',
        content: `<p id="idframe">进入官网下载页面后，请选择运行时windows版本，如下图<a href="https://dotnet.microsoft.com/zh-cn/download/dotnet-framework/net472" target="_blank">
                  (开始点击下载.NET Framework 4.7.2）</a> </p>`
      },
      { type: 'image',
        content: 'netframwork472.png'
      }
    ]
  },
  { type: 'exe',
    name: 'function',
    title: '功能介绍',
    description: 'BooleanDa文档小助手的功能点介绍。',
    date: '2023-7-16',
    values: [
      { type: 'image',
        content: 'top2.png'
      },
      { type: 'text',
        name: 'top1',
        title: '添加印章签名',
        content: `<p>在wrod页面添加印章、签字图片，印章的位置、旋转角度可随机调整。注意由于word版本的差异，插入后需检查一下。</p>
                  <p>同时，因印章处、签名处的位置是按文字搜索，为了保证速度，<span class="text-red">60页以上的文档不建议选用【页面有“公章”字样，
                  则在公章处添加】“在“法定代表人或”字样处，自动添加签名】</span>。 同时，如果公章位置在表格中（比如：技术偏差表等），需再手动调整下图片格式和位置</p>
                  <p><span class="text-red">*注意：如果发现印章图片大小发生变化不一致，请在参数中选择“自定义宽高”</p>`
      },
      { type: 'text',
        name: 'top2',
        title: '核对文档页码',
        content: `<p>检查每个章节的页码是否连续且与实际一致。<span class="text-red">注意：将页码放置在文本框或图形的，暂无法识别，默认是空、无页码！！！</span>。</p>`
      },
      { type: 'text',
        name: 'top3',
        title: '清空文档属性',
        content: `<p>清空文档属性，如作者，主管单位，所有者，计算机。<span class="text-red">目前仅支持doc/docx/xls/xlsx/pdf格式文件</span>。</p>
                  <p>使用前必须先注册dsofile.dll文件<a href="#b2">（查看操作步骤）</a></p>`
      },
      { type: 'text',
        name: 'top4',
        title: 'WORD转PDF',
        content: `<p>将word文档批量转换成PDF文件。</p>`
      },
      { type: 'text',
        name: 'top5',
        title: 'WORD转PDF（双层）',
        content: `<p>将word文档批量转换成双层PDF文件，文件处理流程“word转PDF—>PDF转图片—>图片转PDF—>PDF做OCR—>合并PDF”。</p>`
      },
      { type: 'text',
        name: 'top6',
        title: 'PDF插入新页',
        content: `<p>批量在PDF文件的指定处插入新页面。</p>`
      },
      { type: 'text',
        name: 'top7',
        title: 'PDF替换新页',
        content: `<p>批量在PDF文件替换指定的新页面。</p>`
      },
      { type: 'text',
        name: 'top8',
        title: 'PDF删除页',
        content: `<p>批量删除PDF文件指定页面。</p>`
      },
      { type: 'text',
        name: 'top9',
        title: 'PDF转双层PDF',
        content: `<p>将PDF文件批量转换成双层样式。</p>`
      },
      { type: 'text',
        name: 'top10',
        title: '图片转双层PDF',
        content: `<p>批量将图片直接转换成双层PDF格式，暂支持jpg/png/tiff/jpeg/gif格式。</p>`
      }
    ]
  },
  { type: 'exe',
    name: 'question',
    title: '常见问题',
    description: 'BooleanDa文档小助手使用过程中常见问题及解决方案。',
    date: '2023-7-23',
    values: [
      { type: 'text',
        name: 'top1',
        title: '再次登录时验证失败',
        content: `<p>本软件暂为<b>【一机一码】</b>，在首次登录的电脑验证登录后，暂无法在其他电脑登录使用。如有疑问请联系客服。</p>`
      },
      { type: 'text',
        name: 'top2',
        title: '强制退出代码执行',
        content: `<p>运行中如需强制退出，按Ctrl+Alt+Delete键【任务管理器】—找到进程【BooleanDA.exe】—结束进程，如下图：</p>`
      },
      { type: 'image',
        content: 'end01.png'
      },
      { type: 'text',
        name: 'top3',
        title: '提示word仅只读或占用的情况',
        content: `<p>由于代码是基于OFFICE开发，所以必须使用OFFICE的word作为打开文档的默认程序，如果是默认WPS则会导致程序中断。</p>
                  <p>（1）程序运行时，不要同时打开word文档处理。</p>
                  <p>（2）如果中途代码异常结束，出现被处理的word“文档被占用，只能只读打开时”，请在任务管理器界面，把WORD进程手动结束即可，如下图：。</p>`
      },
      { type: 'image',
        content: 'end_word.png'
      },
      { type: 'text',
        name: 'top4',
        title: '收不到短信验证码的问题',
        content: `<p>为了避免重复发送，短信服务端进行了短信频率的设置，请按情况分析，如下图：</p>`
      },
      { type: 'image',
        content: 'message.png'
      },
      { type: 'text',
        name: 'top5',
        title: '生成的PDF文件过大，如何进行压缩',
        content: `<p>部分PDF文件对大小有要求的，可以在生成双层PDF后进行压缩，操作如下：</p>
                  <p>（1）打开PDF文件，依次选择【工具】-【优化PDF】按钮</p>`
      },
      { type: 'image',
        content: 'pdf1.png'
      },
      { type: 'text',
        name: 'top6',
        title: '',
        content: `<p>（2）在优化界面，点击【减少文件大小】-可以选择【缩减单个文件】或者【多个文件】，然后进行压缩即可：</p>`
      },
      { type: 'image',
        content: 'pdf2.png'
      },
      { type: 'text',
        name: 'top7',
        title: '如何设置PDF导出图片时的分辨率',
        content: `<p>根据项目单位不同要求，对PDF转换的分辨率进行设置，操作如下：</p>
                  <p>（1）打开PDF文件，依次选择【编辑】-【首选项】</p>`
      },
      { type: 'image',
        content: 'exe_pdf_1.png'
      },
      { type: 'text',
        name: 'top8',
        title: '',
        content: `<p>（2）在首选项界面，依次选择【从PDF转换】-选择【TIFF】(注意本软件默认是导出TIFF格式)-点击【编辑设置】：</p>`
      },
      { type: 'image',
        content: 'exe_pdf_2.png'
      },
      { type: 'text',
        name: 'top9',
        title: '',
        content: `<p>（3）在参数设置界面，根据文档要求设置相关参数，然后【确定】</p>`
      },
      { type: 'image',
        content: 'exe_pdf_3.png'
      },
      { type: 'text',
        name: 'top10',
        title: '',
        content: `<p>（4）退出设置后，在主页面也点击【确定】</p>`
      },
      { type: 'text',
        name: 'top11',
        title: '如何设置PDF的OCR参数',
        content: `<p>根据文档质量的不同要求，对OCR进行设置，操作如下：</p>
                  <p>（1）打开PDF文件，依次选择【工具】-【扫描和OCR】</p>`
      },
      { type: 'image',
        content: 'exe_pdf_11.png'
      },
      { type: 'text',
        name: 'top12',
        title: '',
        content: `<p>（2）选择【识别文本】-【在本文件中】：</p>`
      },
      { type: 'image',
        content: 'exe_pdf_12.png'
      },
      { type: 'text',
        name: 'top13',
        title: '',
        content: `<p>（3）选择【设置】，然后按自定义要求设置OCR识别的相关参数：</p>`
      },
      { type: 'image',
        content: 'exe_pdf_13.png'
      },
      { type: 'text',
        name: 'top14',
        title: '',
        content: `<p>（4）设置完成后，点击【确定】结束。</p>`
      }
    ]
  },
  { type: 'word',
    name: 'function',
    title: '功能介绍',
    description: 'Word版BDA小助手功能点介绍，实现图片处理、排版处理表格工具以及插入签名等自定义功能。',
    date: '2023-7-23',
    values: [
      { type: 'text',
        name: 'top1',
        title: '批量设置图片大小',
        content: `<p>系统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020）。</a></p>`
      },
      { type: 'text',
        name: 'top2',
        title: '软件版本要求22',
        content: `<p>系11统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020）。</a></p>`
      },
      { type: 'image',
        content: 'top2.png'
      }
    ]
  },
  { type: 'word',
    name: 'question',
    title: 'word功能介绍3',
    description: 'BooleanDa文档小助手的功能点介绍。',
    date: '2023-7-23',
    values: [
      { type: 'text',
        name: 'top1',
        title: '软件版本要求',
        content: `<p>系统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020）。</a></p>`
      },
      { type: 'text',
        name: 'top2',
        title: '软件版本要求22',
        content: `<p>系11统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020）。</a></p>`
      },
      { type: 'image',
        content: 'top2.png'
      }
    ]
  },
  { type: 'excel',
    name: 'function',
    title: 'excel功能介绍3',
    description: 'BooleanDa文档小助手的功能点介绍。',
    date: '2023-7-23',
    values: [
      { type: 'text',
        name: 'top1',
        title: '软件版本要求',
        content: `<p>系统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020）。</a></p>`
      },
      { type: 'text',
        name: 'top2',
        title: '软件版本要求22',
        content: `<p>系11统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020）。</a></p>`
      },
      { type: 'image',
        content: 'top2.png'
      }
    ]
  },
  { type: 'excel',
    name: 'question',
    title: 'excel功能介绍3',
    description: 'BooleanDa文档小助手的功能点介绍。',
    date: '2023-7-23',
    values: [
      { type: 'text',
        name: 'top1',
        title: '软件版本要求',
        content: `<p>系统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020）。</a></p>`
      },
      { type: 'text',
        name: 'top2',
        title: '软件版本要求22',
        content: `<p>系11统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020）。</a></p>`
      },
      { type: 'image',
        content: 'top2.png'
      }
    ]
  },
  { type: 'pdf',
    name: 'function',
    title: 'pdf功能介绍3',
    description: 'BooleanDa文档小助手的功能点介绍。',
    date: '2023-7-23',
    values: [
      { type: 'text',
        name: 'top1',
        title: '软件版本要求',
        content: `<p>系统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020）。</a></p>`
      },
      { type: 'text',
        name: 'top2',
        title: '软件版本要求22',
        content: `<p>系11统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020）。</a></p>`
      },
      { type: 'image',
        content: 'top2.png'
      }
    ]
  },
  { type: 'pdf',
    name: 'question',
    title: 'pdf功能介绍3',
    description: 'BooleanDa文档小助手的功能点介绍。',
    date: '2023-7-23',
    values: [
      { type: 'text',
        name: 'top1',
        title: '软件版本要求',
        content: `<p>系统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020）。</a></p>`
      },
      { type: 'text',
        name: 'top2',
        title: '软件版本要求22',
        content: `<p>系11统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020）。</a></p>`
      },
      { type: 'image',
        content: 'top2.png'
      }
    ]
  },
  { type: 'question',
    name: 'function',
    title: 'question功能介绍3',
    description: 'BooleanDa文档小助手的功能点介绍。',
    date: '2023-7-23',
    values: [
      { type: 'text',
        name: 'top1',
        title: '软件版本要求',
        content: `<p>系统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020）。</a></p>`
      },
      { type: 'text',
        name: 'top2',
        title: '软件版本要求22',
        content: `<p>系11统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020）。</a></p>`
      },
      { type: 'image',
        content: 'top2.png'
      }
    ]
  },
  { type: 'question',
    name: 'question',
    title: 'questionquestionquestion',
    description: 'BooleanDa文档小助手的功能点介绍。',
    date: '2023-7-23',
    values: [
      { type: 'text',
        name: 'top1',
        title: '软件版本要求',
        content: `<p>系统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020）。</a></p>`
      },
      { type: 'text',
        name: 'top2',
        title: '软件版本要求22',
        content: `<p>系11统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
                  <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
                  <p>Acrobat版本：<b>Adobe Acrobat DC 32位</b> <a href="http://www.booleanda.cc:9600" target="_blank">
                  (前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020前往下载破解版2020）。</a></p>`
      },
      { type: 'image',
        content: 'top2.png'
      }
    ]
  }
]

export var dataList = arr
